import React, { ReactChild } from "react";
import { colorTheme } from "../../functions/colorUtils";
import { IconSVG } from "./IconSVG";

interface IconProps extends React.HtmlHTMLAttributes<HTMLButtonElement> {
  icon?: string | boolean;
  iconRight?: string;
  size?: string;
  label?: string | ReactChild;
  labelClass?: string;
  tintColor?: string;
}

export const IconLabel = ({
  icon,
  iconRight,
  label,
  labelClass = "",
  tintColor,
  ...rest
}: IconProps) => {
  return (
    <div className="d-flex align-items-center">
      {icon && (
        <IconSVG
          icon={icon as string}
          {...rest}
          tintColor={tintColor || colorTheme.primary}
        />
      )}

      <span className={labelClass}>{label}</span>
      {iconRight && (
        <IconSVG
          icon={iconRight}
          {...rest}
          tintColor={tintColor || colorTheme.primary}
        />
      )}
    </div>
  );
};
